import { SEND_CONTACT_EMAIL } from 'actions/legal';
import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';

function* sendContactEmail(action) {
  try {
    const response = yield call(API.sendContactEmail, action.payload);
    yield put({ type: SEND_CONTACT_EMAIL.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: SEND_CONTACT_EMAIL.FAIL, payload: { error: e } });
  }
}

function* legal() {
  yield takeLatest(SEND_CONTACT_EMAIL.REQUEST, sendContactEmail);
}

export default legal;
